export const atribInputDialog = {
    id: 'codigoSms',
    name: 'codigoSms',
    type: 'text',
    disabeld: false    
}

export const properties = {
    RESOURCE_SMS: 'p3s',
    URL_ENVIAR_SMS: '/enviarSMS',
    RESOURCE_DATOS_CONTACTO: 'datos-contacto',
    URL_TLF_MOVIL: '/getTlfMovFromDcXdefecto/',
    URL_COMPROBAR_CODIGO: '/consulta/',
}